import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"

import css from "./CategoryTree.scss"
import { fetchCategories } from "./reducer"
import { checkReducerAdded } from "@wrappers/ErrorBoundary/index.js"

import ChildrenItem from "./ChildrenItem"

const DesktopUdp = ({ udpData }) => (
    <ul className={`${css.container}`}>
        {udpData?.length && udpData.map((item, i) => <ChildrenItem item={item} key={i} id={i} />)}
    </ul>
)

const CategoryTree = () => {
    const dispatch = useDispatch()

    const { data } = useSelector((state) => checkReducerAdded(state.categoryTreeReducer))

    useEffect(() => {
        if (!data?.length) {
            dispatch(fetchCategories())
        }
    }, [])

    return (
        <div className="smallRegular">
            <DesktopUdp udpData={data} />
        </div>
    )
}

DesktopUdp.propTypes = {
    udpData: PropTypes.array,
}

export default CategoryTree
